export const isV2Enabled = (envVariable: string): boolean =>
  process.env[envVariable] === "enabled" ||
  localStorage.getItem(envVariable) === "enabled";
